package com.arena_web.data.dto

import kotlinx.serialization.Serializable

@Serializable
data class SportDto(
    val id: String,
    val name: String,
    val icon: String,
    val maxPlayersPerTeam: Int,
    val minPlayersPerTeam: Int,
    val createdAt: String,
    val updatedAt: String
)

@Serializable
data class SportAttributeDto(
    val id: String,
    val name: String,
    val weight: Double,
    val displayOrder: Int
)

@Serializable
data class SportPositionDto(
    val id: String,
    val name: String,
    val displayOrder: Int
)

@Serializable
data class SportStatTypeDto(
    val id: String,
    val sportId: String,
    val name: String,
    val displayKey: String,
    val displayOrder: Int,
    val scope: String
)

@Serializable
data class FormationDto(
    val id: String,
    val name: String
)
